"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioButtonDocument = void 0;
var types_1 = require("../../../types");
exports.radioButtonDocument = {
    dateCreated: "2021-07-26T19:09:11Z",
    form: {
        actions: [],
        allowedDocumentEditor: "DOCUMENT_CREATOR",
        defenses: [],
        displayConditions: [],
        id: 1195001,
        isRehuddleEligible: true,
        lastModifiedDate: "2021-07-16T17:09:45.848668Z",
        name: "Some Radio Buttons",
        properties: null,
        relationshipTypes: [],
        rootId: 1195001,
        sections: [
            {
                id: 1195101,
                items: [
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1195503,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1195403,
                        },
                        hasDefenses: false,
                        id: 1195403,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-07-16T17:09:45.736684Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: {},
                        rootId: 1195403,
                        selections: [
                            {
                                defenseIds: [],
                                id: 1195551,
                                rootId: 1195551,
                                tags: [],
                                title: "Option 1",
                            },
                            {
                                defenseIds: [],
                                id: 1195552,
                                rootId: 1195552,
                                tags: [],
                                title: "Option 2",
                            },
                        ],
                        subType: "RADIO_BUTTONS",
                        tags: [],
                        title: "Custom Options",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "123423",
                            id: 1195351,
                            isFromWidget: null,
                            properties: {
                                answerField: "value",
                                autoComplete: false,
                                dataSourceId: 570751,
                                detailedSearch: {
                                    infiniteListSortBy: "displayOrder,value",
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        formProperties: {
                            id: 1195302,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1195202,
                        },
                        hasDefenses: false,
                        id: 1195202,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-07-16T17:09:45.747314Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1195202,
                        selections: [],
                        subType: "RADIO_BUTTONS",
                        tags: [],
                        title: "Colors",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1210569,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1210705,
                        },
                        hasDefenses: false,
                        id: 1210705,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-08-12T12:49:28.069815Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1210705,
                        selections: [],
                        subType: "TEXT_LINE",
                        tags: [],
                        title: "Selected Color",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "WORK_LOCATION",
                            id: 1195352,
                            isFromWidget: null,
                            properties: {
                                answerField: "name",
                                autoComplete: false,
                                dataSourceId: 1300,
                                detailedSearch: {
                                    infiniteListSortBy: "name",
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        formProperties: {
                            id: 1195501,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1195401,
                        },
                        hasDefenses: false,
                        id: 1195401,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-07-16T17:09:45.759227Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1195401,
                        selections: [],
                        subType: "RADIO_BUTTONS",
                        tags: [],
                        title: "Work Locations",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                ],
                parentWidgetRootId: null,
                properties: null,
                rootId: 1195101,
                title: null,
                workflowType: "FINAL",
            },
        ],
        sharingEnabled: true,
        signatureRequired: null,
        startFromWorkOrderEnabled: true,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    formActionRequests: [],
    formSummary: {
        id: 1195001,
        name: "Some Radio Buttons",
        rootId: 1195001,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    id: 1201151,
    operationalExperiences: [],
    owner: {
        fullName: 'Riley, Todd "The Toddster"',
        name: "Todd Riley",
        participantId: 1062251,
    },
    participants: [],
    photos: [],
    readOnly: false,
    responses: [],
    resubmissions: [],
    sectionComments: [],
    startDate: "2021-07-26T19:09:11Z",
    status: types_1.DocumentStatus.NEW,
    submissionDate: "2021-07-26T19:09:11Z",
    submissionId: 1201201,
    submissionType: types_1.DocumentSubmissionType.NEW,
    summary: {},
    title: "New Document",
};
//# sourceMappingURL=radioButtonDocument.js.map